// Vendors
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
// Constants
import { CURRENCY_STYLE } from './constants/financial-data-detail.constants';
// Styles
import {
  FinancialDataContainerStyled,
  FinancialDataNameStyled,
  FinancialDataQuantityStyled,
} from './financial-data-detail.component.styled';
// Types
import { FinancialDataDetailComponentType } from './types/financial-data-detail.component.type';
import { EVERY_MONTH_INSTALLMENTS } from '../../translations/financial-data.component.translations';

const FinancialDataDetailComponent = ({
  detail,
}: FinancialDataDetailComponentType): React.JSX.Element => (
  <FinancialDataContainerStyled key={detail.label}>
    <FinancialDataNameStyled>
      <FormattedMessage
        id={detail.label}
        values={{
          nominalInterest: (
            <FormattedNumber value={detail.nominalInterest} minimumFractionDigits={2} />
          ),
          interestRate: <FormattedNumber value={detail.interestRate} minimumFractionDigits={2} />,
        }}
      />
    </FinancialDataNameStyled>
    <FinancialDataQuantityStyled>
      {detail.installments ? (
        <FormattedMessage
          id={EVERY_MONTH_INSTALLMENTS}
          values={{
            installments: detail.installments,
            installmentValue: (
              <FormattedNumber
                style={CURRENCY_STYLE}
                value={detail.value}
                currency={detail.currency}
              />
            ),
          }}
        />
      ) : (
        <FormattedNumber style={CURRENCY_STYLE} value={detail.value} currency={detail.currency} />
      )}
    </FinancialDataQuantityStyled>
  </FinancialDataContainerStyled>
);
export { FinancialDataDetailComponent };
